import './document/teleconsent.action.document';
import './select/teleconsent.action.select';
import './share/teleconsent.action.share';
import _ from 'lodash';
import EventEmitter from 'utility/event-emitter';
import stampit from 'stampit';

import pagedTeleconsentShare from './share/paged/teleconsent-share/paged.teleconsent-share.js';
import tcModalAdaptive from './paged-document/document.tc-modal-adaptive';
import tcMobileTopMenu from './paged-document/menu/menu.tc-mobile-top-menu';
import pagedDocumentPreview from './paged-document/document.paged-document-preview';
import { determineReceiverLocatedStatus } from '../../../../modules/core/helpers/tracking-helpers';
import { PeopleCollection } from '../../../common/services/people-collection';
import { download } from '../../../common/directives/d-download';
import { DocumentTeleconsentType } from '../../../../modules/teleconsent/types';
import {
  hasGrowthBookFeature,
  GrowthBookFeatures,
} from '../../../../modules/core';

angular
  .module('doxy.realtime.components.teleconsent.action', [
    'doxy.realtime.components.teleconsent.action.select',
    'doxy.realtime.components.teleconsent.action.document',
    'doxy.realtime.components.teleconsent.action.share',
    pagedTeleconsentShare,
    pagedDocumentPreview,
    tcModalAdaptive,
    tcMobileTopMenu,
  ])
  .factory('tcDataParser', function ($filter) {
    function getDynamicDefaults() {
      return { now: new Date() };
    }

    return {
      toDynamicKey(key) {
        return '$$' + key + '$$';
      },

      parse(data) {
        var dynamicDefaults = getDynamicDefaults();
        var dynamicData = (/^(\$\$(.+?)\$\$)/.exec(data) || []).pop();
        var keys = dynamicData
          ? dynamicData.split('|').map(function (key) {
              return key.trim();
            })
          : null;

        if (!keys || !dynamicDefaults[keys[0]]) return data;
        var dynamicValue = dynamicDefaults[keys[0]];
        return keys[1]
          ? $filter(keys[1])(dynamicValue, keys[2], keys[3])
          : dynamicValue;
      },

      parseFields(fieldsMetadata) {
        var _this = this;
        return Object.keys(fieldsMetadata).reduce(function (result, key) {
          result[key] = _this.parse(fieldsMetadata[key].data);
          return result;
        }, {});
      },
    };
  })
  .factory(
    'TeleconsentRealtimeComponent',
    function (
      $rootScope,
      $modal,
      $timeout,
      Institution,
      Document,
      TeleconsentDocument,
      trackingFactory,
      RealtimeComponent,
      currentUserHelper,
      notificationFactory,
      $log,
      pn,
      scrollFactory,
      VideoProviderFactory,
      roomHelpersFactory,
      $ngRedux
    ) {

      function _newModal(template, contentTemplate, extra) {
        const defaultTemplate =
          '/app/realtime/components/teleconsent/action/share/teleconsent.action.share.modal-template.tpl.html';
        this.modal = $modal(
          _.extend(
            {
              scope: this.$scope,
              contentTemplate: contentTemplate,
              placement: '',
              keyboard: false,
              backdrop: 'static',
              template: template || defaultTemplate,
              animation: 'none',
            },
            extra
          )
        );
      }

      function _newFinalModal(template, extra) {
        this.modal = $modal(
          _.extend(
            {
              scope: this.$scope,
              contentTemplate: template,
              placement: '',
              keyboard: false,
              backdrop: 'static',
              template:
                '/app/realtime/components/teleconsent/action/final/' +
                'teleconsent.action.final.modal-template.tpl.html',
            },
            extra
          )
        );
      }

      function _hideModal() {
        if (this.modal) {
          this.modal.hide();
          this.modal = null;
        }
        (this.$scope || $rootScope).$emit('modal.hide');
      }

      const basePath = '/app/realtime/components/teleconsent/action/';

      const defaultState = {
        documentId: null,
        institution: null,
      };

      let _initialRoomId = null;
      let _initialSessionId = null;

      return stampit({
        deepProps: {
          $scope: null,
          innerMediator: null,
          target: null,
          state: _.clone(defaultState),
          modal: null,
          peopleCollection: null,
          componentName: 'teleconsent',
          events: {
            share: 'onShare',
            final: 'teleconsentFinal',
            close: 'onClose',
            collaboration: 'onCollaboration',
          },
        },
        methods: {
          open({ peopleAvailable }) {
            this.peopleAvailable = peopleAvailable;
            if (peopleAvailable && peopleAvailable.getMobileUsers().length) {
              notificationFactory.showCommon(
                'info',
                'Teleconsent currently ' + 'does not support mobile devices'
              );
              return;
            }

            this.init({});
            this.teleconsentSelect();
          },

          getPeopleNames() {
            return this.peopleCollection
              .map((p) => p.state.username)
              .join(', ');
          },

          onShare({ documentId }, target) {
            this.peopleAvailable = new PeopleCollection([target]);
            this.init({ state: { documentId } });
            this.openTeleconsentShare(documentId);
          },

          init({ state }) {
            _initialRoomId = _.get(roomHelpersFactory.getRoom(), 'id');
            _initialSessionId = _.get(
              VideoProviderFactory,
              'activeProvider.callSession.id',
              null
            );
            this.close();
            this.parent = this;
            this.state.institution = currentUserHelper.institution;
            _.extend(this.state, state);
            this.innerMediator = new EventEmitter();
            this.peopleCollection = this.peopleAvailable;
            this.peopleNames = this.getPeopleNames();
            this.$scope = $rootScope.$new(true);
            _.extend(
              this.$scope,
              _.pick(this, [
                'state',
                'innerMediator',
                'peopleCollection',
                'parent',
              ])
            );
            this.$scope.me = _.extend({}, this.userState, {
              type: this.state.documentId !== null ? 'p' : 'r',
            });
            VideoProviderFactory.decorateScope(this.$scope);
            this.innerMediator.addListeners({
              click: this.collaboration.bind(this, 'click'),
              navigate: this.collaboration.bind(this, 'navigate'),
              scroll: this.collaboration.bind(this, 'scroll'),
              mouse: this.collaboration.bind(this, 'mouse'),
              data: this.collaboration.bind(this, 'data'),
              submit: this.collaboration.bind(this, 'submit'),
              resize: this.collaboration.bind(this, 'resize'),
              cancel: ({ notify }) => {
                if (notify) this.sendToAll('close');
                this.close();
              },

              select: this.teleconsentSelect.bind(this),
              preview: this.preview.bind(this),
              'select:cancel': this.close.bind(this),
              share: (data) => {
                this.startTeleconsentShare(data);
              },

              final: ({ data, documentType, isDefault, documentName }) => {
                const isTypeDefault =
                  documentType === DocumentTeleconsentType.default || isDefault;

                trackingFactory.global.track('Consent Finalized', {
                  room_id: _initialRoomId,
                  session_id: _initialSessionId,
                  consent_type: Boolean(isTypeDefault) ? 'default' : 'custom',
                  ...(Boolean(isTypeDefault)
                    ? {
                        consent_name: documentName.toLowerCase(),
                      }
                    : null),
                });

                this.sendToAll('final', data);
                this.teleconsentFinal(data);
              },
            });
            this.$scope.endTeleconsent = () => {
              this.close();
            };
            this.$scope.onDownload = (forceClose = false) => {
              download(this.$scope.selectedDocument.url);
              this.$scope.state.downloaded = true;

              const isTypeDefault =
                this.$scope.selectedDocument.type ===
                  DocumentTeleconsentType.default ||
                this.$scope.selectedDocument.isDefault;

              trackingFactory.global.track('Consent Downloaded', {
                room_id: _initialRoomId,
                session_id: _initialSessionId,
                consent_type: Boolean(isTypeDefault) ? 'default' : 'custom',
                ...(currentUserHelper.getUserType() === null
                  ? { user_type: 'patient' }
                  : {}),
              });
              if (forceClose) {
                this.$scope.endTeleconsent(this.$scope.state.downloaded);
              }
            };

            this.$scope.closeShare = () => {
              this.sendToAll('close');
              this.close();
            };
            this.$scope.confirmFinalizeShare = () => {
              this.$scope.selectedDocument.finalizePages();
            };
            $rootScope.$on('tcDocument:closeShare', this.$scope.closeShare);
          },

          _onLeave(_person) {
            /**
             * Do nothing.
             * Keep the extension open because provider or patient could leave and rejoin multiple times on unstable connection.
             */
          },

          _onShare(document) {
            this.innerMediator.emit('share', document);
          },

          close() {
            if (!this.$scope) return;
            _hideModal.call(this);
            this.innerMediator.removeAllListeners();
            this.$scope.$destroy();
            this.state = _.clone(defaultState);
            this.$scope = this.target = this.innerMediator = null;
            $rootScope.$emit('tcPagedDocument:clear');
          },

          onClose(message, person) {
            notificationFactory.showCommon(
              'info',
              'teleconsentPersonEnded',
              null,
              null,
              {
                username: person.state.username,
              }
            );
            this.close();
          },

          sendToAll(action, content) {
            this.peopleCollection.forEach((person) => {
              this.send(person.uuid, action, content);
            });
          },

          collaboration(type, data) {
            this.sendToAll('collaboration', { type, data });
          },

          onCollaboration(message, person) {
            if (!this.innerMediator) return;
            this.innerMediator.emit(
              `${message.type}:get`,
              message.data,
              person
            );
          },

          preview(document) {
            _hideModal.call(this);
            let modalTemplate = `${basePath}preview/teleconsent.action.preview.tpl.html`;

            if (document.metadata.pages) {
              modalTemplate = `${basePath}preview/teleconsent.action.preview-paged.tpl.html`;
            }
            this.$scope.selectedDocument = angular.copy(document);
            this.$scope.onShare = this._onShare;
            _newModal.call(this, undefined, modalTemplate, {
              keyboard: true,
              backdrop: true,
            });
          },

          teleconsentSelect() {
            _hideModal.call(this);
            this.modal = $modal({
              scope: this.$scope,
              contentTemplate: `${basePath}select/teleconsent.action.select.modal.tpl.html`,
            });
          },

          startTeleconsentShare(document) {
            const { id, name, type, isDefault } = document;
            const targetPatientUUID = this.peopleAvailable.models[0].uuid;
            const receiverLocatedStatus = determineReceiverLocatedStatus(
              targetPatientUUID,
              $ngRedux.getState()
            );
            const isTypeDefault =
              type === DocumentTeleconsentType.default || isDefault;

            trackingFactory.global.track('Consent Requested', {
              room_id: _initialRoomId,
              session_id: _initialSessionId,
              consent_type: Boolean(isTypeDefault) ? 'default' : 'custom',
              receiver_located: receiverLocatedStatus,
              ...(Boolean(isTypeDefault)
                ? {
                    consent_name: name.toLowerCase(),
                  }
                : null),
            });
            const documentId = document.documentId;
            this.state.documentId = documentId;
            this.openTeleconsentShare(documentId);
            this.sendToAll('share', { documentId });
          },

          teleconsentFinal({ url }) {
            $log.info('teleconsentFinal');
            _hideModal.call(this);
            this.innerMediator.removeAllListeners();
            scrollFactory.enableScroll();
            this.$scope.selectedDocument.url = url;
            _newFinalModal.call(
              this,
              `${basePath}final/teleconsent.action.final.tpl.html`
            );
          },

          viewDocument(document) {
            this.$scope.selectedDocument = document;

            const userState = this.userState;
            let template = undefined;

            let modalTemplate = `${basePath}share/teleconsent.action.share.modal.tpl.html`;

            if (document.metadata.pages) {
              template = `${basePath}share/paged/share.paged.modal-template.tpl.html`;

              modalTemplate = `${basePath}share/paged/share.paged.modal.tpl.html`;

              $rootScope.$emit('tcPagedDocument', document);

              if (userState.mobileBrowser && pn.isPatient()) {
                template = `${basePath}share/paged/share.paged.modal-template-patient-mobile.tpl.html`;
              }

              if (!userState.mobileBrowser && pn.isPatient()) {
                template = `${basePath}share/paged/share.paged.modal-template-patient-desktop.tpl.html`;
              }
            }

            _newModal.call(this, template, modalTemplate);
          },

          openTeleconsentShare(documentId) {
            const modalTimeout = this.modal ? 500 : 0; // wait 500ms for previous modal to close when doctor clicks "share"

            _hideModal.call(this);
            Promise.all([
              TeleconsentDocument.getByDocumentId({ documentId }).$promise,
              $timeout(angular.noop, modalTimeout),
            ]).then(([document]) => {
              document.data = {};
              this.viewDocument(document);
            });
          },

          reset() {
            this.hideModal();
            if (this.innerMediator) this.innerMediator.removeAllListeners();
            if (this.$scope) this.$scope.$destroy();
            this.$scope = this.target = this.innerMediator = null;
          },
        },
      }).compose(RealtimeComponent);
    }
  );
